<template>
	<v-card flat class="mb-2 pt-2">
		<v-layout>
			<v-flex>
				<v-card-title primary-title class="py-0 mb-2 pr-0">
					<v-layout align-center>
						<span class="subheading font-weight-bold">{{ item.authorName }}</span>
						<v-spacer />
						<template v-if="isAuthor">
							<template v-if="isEditing">
								<v-btn icon flat small class="my-0" color="error" @click="cancelCommentChanges">
									<v-icon>mdi-close</v-icon>
								</v-btn>
								<v-btn icon flat small class="my-0" color="primary" @click="saveComment">
									<v-icon>mdi-check</v-icon>
								</v-btn>
							</template>
							<menu-edit v-else
								small
								:message="$t('COMMENT_DELETE_CONFIRM_TITLE')"
								:details="$t('COMMENT_DELETE_CONFIRM_DETAILS')"
								@edit="editComment"
								@remove="deleteComment" />
						</template>
					</v-layout>
				</v-card-title>
				
				<v-card-text
					class="py-0 body-1 text-xs-justify user-text"
					v-if="!isEditing">{{ item.text }}</v-card-text>
				<v-textarea
					v-else
					class="ml-3"
					:label="$t('COMMENT_EDIT_LABEL')"
					v-model="editDialogCopy.text"
					box
					auto-grow
					rows="1"
					hide-details
					@click:append-outer="saveComment" />

				<v-card-actions class="py-0 pl-3 mt-2">
					<span class="text--secondary font-italic caption" :title="item.createdAt | toAbsoluteDate">
						{{ item.createdAt | toRelativeDate }}
					</span>
					<v-icon class="ml-2" small color="orange" v-if="isEdited" v-bind:title="item.updatedAt | toAbsoluteDate">mdi-pencil</v-icon>
				</v-card-actions>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
import { toRelativeDate, toAbsoluteDate } from '@/utils/formatters';
import { mapGetters } from 'vuex';
import MenuEdit from '@/dialogs/MenuEdit';

export default {
	name: 'action-comment',
	components: { MenuEdit },
	props: {
		item: Object,
	},
	computed: {
		...mapGetters('auth', ['userID']),
		...mapGetters('comments', ['editDialogCopy']),
		isEdited() {
			return this.item && this.item.createdAt !== this.item.updatedAt;
		},
		isAuthor() {
			return this.item.author === this.userID;
		},
		isEditing() {
			return this.editDialogCopy && this.editDialogCopy.id === this.item.id;
		},
	},
	filters: {
		toRelativeDate,
		toAbsoluteDate,
	},
	methods: {
		editComment() {
			this.$store.dispatch('comments/editComment', { item: this.item });
		},
		cancelCommentChanges() {
			this.$store.dispatch('comments/cancelCommentChanges', { item: this.editDialogCopy });
		},
		async saveComment() {
			this.$emit('edit', this.editDialogCopy);
		},
		async deleteComment() {
			this.$emit('remove', this.item);
		},
	},
}
</script>
